module.exports = __webpack_public_path__ + "img/hr-roboport-base-patch.b87f56c5.png";